module.exports = __webpack_public_path__ + "static/media/Data-Analyst.81ebd8df.png";